import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { toast_error } from "../../config/Constant";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageHeading from "../../components/pageHeading/PageHeading";
import "./viewProfile.scss";
import ProfileImg from "../../assets/images/user.jpg";
import { LocationIcon} from "../../components/Icons";

import { Button } from "react-bootstrap";
import OverAllRating from "../../components/overAllRating/OverAllRating";

import Comments from "../../components/comments/Comments";
import LeaveFeedback from "../../components/leaveFeedback/LeaveFeedback";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchProviderDetails } from "../../services/hireProvider.service";
import { fetchImage, getFullName } from "../../utils/common";
import { setLoader, userId } from "../../slice/commonSlice";
import { selectUser } from "../../slice/authSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProviderRatingDetail,
  fetchProviderServiceDetail,
  fetchProviderServiceList,
} from "../../services/auth.service";
import StarRating from "../../components/rating/StarRating";



const ViewProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [profile, setProfile] = useState();
  const [rating, setRating] = useState();
  const [activeTab, setActiveTab] = useState("");
  const [providerService, setProviderServices] = useState([]);
  const [serviceDetails, setServiceDetails] = useState({});
  let id = location.state?.id;
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  //useEffect and function call to get provider profile

  useEffect(() => {
    if (id && location.state?.serviceId) {
      getProfile();
      fetchServiceDetails(location.state?.serviceId);
    }
  }, [id, location.state?.serviceId]);
  const getProfile = async () => {
    let payload = {
      _id: id,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderDetails(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setProfile(response.data);
        getProviderServiceList(id);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };
  const getProviderServiceList = async () => {
    let payload = {
      providerId: id,
    };

    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderServiceList(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setProviderServices(response.data);
        if (response?.data?.length > 0) {
          setActiveTab(response?.data[0]?.serviceId?.name);
          fetchRating(response?.data[0]?.serviceId?._id);
        }
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const fetchRating = async (serviceId) => {
    let payload = {
      providerId: id,
      serviceId: serviceId,
      pageNumber: 1,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderRatingDetail(payload);
      await dispatch(setLoader(false));
      if (response.data.status) {
        // console.log("response.data.ratings==>",response.data.ratings)
        setRating(response.data.ratings);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const fetchServiceDetails = async (serviceId) => {
    let payload = {
      providerId: id,
      serviceId: serviceId,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderServiceDetail(payload);
      await dispatch(setLoader(false));
      if (response.data.status) {
        setServiceDetails(response.data.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };
  const gotToProviderAvailability = () => {
    if (user === null) {
      toast.error("Login is mandatory", toast_error);
      return; // Exit the function if the user is not logged in
    } else {
      let payload = {
        providerId: id,
        serviceId: location.state?.serviceId,
        serviceName: location.state?.serviceName,
        jobType: location.state?.jobType,
        unitPrice: serviceDetails?.rate,
        policyText: profile?.policyText,
      };
      // console.log("provider===>", profile)
      if (profile?.personData?.marketingEmail !== null) {
        navigate("/consumer/marketingjob", { state: { providerId: id } });
      } else if (location?.state?.jobType === "services") {
        navigate("/consumer/availabilty", { state: payload });
      } else if (
        location?.state?.jobType === "moving" ||
        location?.state?.jobType === "delivery"
      ) {
        navigate("/consumer/job/trucking", { state: payload });
      }
    }


  };

  const handleRating = (name, serviceid) => {
    setActiveTab(name);
    fetchRating(serviceid);
  };

  return (
    <>
      <Header />
      <PageHeading title="View Profile" />
      <div className="profile-banner-wrapper">
        <div className="profile-detail-wrap">
          <div className="profile-pic">
            <img
              src={profile?.personData?.profilePic}
              alt="Profile"
            />
          </div>
          <div className="profile-detail">
            <div className="profile-name">
              {getFullName(
                profile?.personData?.firstName,
                profile?.personData?.lastName
              )}
            </div>
            <div className="rating-wrap">
              <div className="rating">
                <StarRating
                  size={28}
                  rating={profile?.personData?.ratingProvider}
                />
                {/* <StarFill /> <StarFill /> <StarFill /><StarFill /> <StarOutline /> */}
              </div>
              <div className="rating-value">
                {profile?.personData?.ratingProvider !== null
                  ? `(${profile?.personData?.ratingProvider})`
                  : `(0)`}{" "}
                - {profile?.personData?.numberOfRatings} Reviews
              </div>
            </div>
            <div className="profile-location">
              <div className="profile-location-text">
                <div className="icon-wrap">
                  <LocationIcon />
                </div>
                {profile?.personData?.location}
              </div>
            </div>
          </div>
          <div className="hire-btn-wrap">
            <Button
              variant="light"
              onClick={() => {
                gotToProviderAvailability();
              }}
            >
              Hire Me
            </Button>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-wrap profile-content-wrapper">
          <div className="w-100">
            {profile?.personData?.bio
              ?.split(" ")
              .slice(0, 100)
              .join(" ")}{profile?.personData?.bio?.split(" ").length > 100 && "..."}
          </div>

          <OverAllRating data={profile?.personData} />
          {serviceDetails?.images?.length ? (
            <div className="w-100  gallery-wrapper">
              <div className="section-heading">Gallery</div>
              <div className="gallery-img-wrap">
                {serviceDetails?.images?.map((item, index) => (
                  <div className="gallery-img" key={index}>
                    <img src={item} alt="service image" />
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          <div className="w-100 filter-review-wrap">
            <div className="section-heading">Filter Review By Service</div>
            <div className="filter-tab-wrap w-100">
              <ul className="filter-tab w-100">
                {providerService?.length > 0 ? (
                  <>
                    {providerService?.map((item, index) => (
                      <li
                        onClick={() =>
                          handleRating(
                            item?.serviceId?.name,
                            item?.serviceId?._id
                          )
                        }
                        className={
                          activeTab === item?.serviceId?.name ? "active" : ""
                        }
                        key={index}
                      >
                        {item?.serviceId?.name}
                      </li>
                    ))}
                  </>
                ) : null}
              </ul>
              <div className="filter-tab-content">
                <div className="filter-tab-title">{activeTab}</div>
                <Comments rating={rating} />
              </div>
            </div>
          </div>

          {/* <LeaveFeedback /> */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ViewProfile;